// a11y.ts — reduced-motion support. Defaults to the OS `prefers-reduced-motion` setting, and a
// toggle in the JUICE header lets anyone flip it. When on, the big vestibular-triggering motion is
// skipped (screenshake, tile/reel poses, wind-up jiggle, flying particles) while the READABLE parts
// stay — brow expressions, colour skins, sound, the count-up. You can still see what's happening;
// it just doesn't lurch around.

// reduceMotion = the FULL accessibility reduction (skips tweens, pops, particles, poses AND shake —
// only brows/colour/sound survive). Driven by the OS `prefers-reduced-motion` setting; it is NOT the
// everyday default (that would kill nearly all the juice). Genuine a11y users opt in via the OS.
let reduced = false;
try {
  reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
} catch {
  reduced = false;
}

export function reduceMotion(): boolean {
  return reduced;
}

// "Calm" — suppress ONLY the whole-screen shake, while keeping every localized juice (tweens, tile
// pops, particles, personality poses). This is the everyday DEFAULT: the tool opens fully lively but
// never jolts the screen; the footer toggle flips it. The welcome + mash buttons also force it during
// their fire (then restore) so a drop-in visitor is never lurched regardless of the toggle.
let calm = true;
export function isCalm(): boolean {
  return calm;
}
export function setCalm(on: boolean): void {
  calm = on;
}

export function setReduceMotion(on: boolean): void {
  reduced = on;
  document.body.classList.toggle("reduce-motion", on);
}

/** Apply the initial state (OS default) to the body once at boot. */
export function initReduceMotion(): void {
  document.body.classList.toggle("reduce-motion", reduced);
}
